import { DataSource } from '@angular/cdk/collections';
import { Observable, BehaviorSubject, of } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { IPagedResult } from 'src/app/shared/models/pagedResult';
import { ProfileHistory } from '../models/profileHistory';
import { HistoryService } from '../services/history.service';

export class ProfileFieldHistoryDataSource implements DataSource<ProfileHistory> {
  private historySubject = new BehaviorSubject<ProfileHistory[]>([]);
  private loadingSubject = new BehaviorSubject<boolean>(false);
  private rowCountSubject = new BehaviorSubject<number>(0);
  public loading$ = this.loadingSubject.asObservable();
  public rowCount$ = this.rowCountSubject.asObservable();
  constructor(private historyService: HistoryService) {}
  connect(): Observable<ProfileHistory[]> {
    return this.historySubject.asObservable();
  }
  disconnect(): void {
    this.historySubject.complete();
    this.loadingSubject.complete();
    this.rowCountSubject.complete();
  }
  loadHistory(pageIndex: number, pageSize: number, personId?: string, attributeName?: string) {
    this.loadingSubject.next(true);
    this.historyService
      .profileFieldHistory(pageIndex, pageSize, personId, attributeName)
      .pipe(
        catchError(() => of<IPagedResult<ProfileHistory>>({ rowCount: 0, results: [] })),
        finalize(() => this.loadingSubject.next(false))
      )
      .subscribe(({ results, rowCount }) => {
        this.historySubject.next(results);
        this.rowCountSubject.next(rowCount);
      });
  }
}
